<template>
      <!-- <div class="box box-info"> -->
        <form >
            <website ref="website"/>
            <!-- <div class="name"> -->
       <!-- <div class="card">
          <DataView :value="displayItemList" :paginator="true" style="width: 80%;margin-top: 3%;" :rows="28" :layout="layout">
            <template #header>
              <div class="p-grid p-nogutter">
              <InputText v-model="searchTerm"  style="float:right"  placeholder="Please enter keyword"  @input="searchItemWithUserInput"/>

              </div>
            </template>
            <template #grid="slotProps">
              <div class="p-col-12 p-md-3" style="border-bottom: 0px solid #c8c8c8;">
                <div class="product-grid-item card">
                  <div class="product-grid-item-top">
                    <div>
                      <i class="pi pi-tag product-category-icon"></i>
                      <span class="product-category">{{slotProps.data.groupName}}</span>
                    </div>
                  </div>
                  <div >
                    <a href="" @click="viewProductDetailsPage(slotProps.data)">
                      <img :src="slotProps.data.singleImageUrl" :alt="slotProps.data.name" style="width: 75%;height:75%"/></a>
                  
                    <h4 class="p-mb-1">{{slotProps.data.name}}</h4>
                    <h6 class="p-mt-0 p-mb-3">{{slotProps.data.salesRate}}</h6>
                    <div class="product-description">{{slotProps.data.description}}</div>
                  </div>
                   <div class="car-buttons p-mt-2" style="margin: 0% 0% 0% 26%;">
                        <Button icon="pi pi-eye" @click="viewProductDetailsPage(slotProps.data)" class="p-button raised" />
                        <Button icon="pi pi-shopping-cart" class="p-button-success p-mr-2" />
                    </div>
                </div>
              </div>
            </template>
          </DataView>
        </div> -->
               <div class="page-width">
         <div  class="grid">
           <div class="grid__item medium-up--four-fifths large--three-quarters main-col right">
             <div class="productList">
          <DataView :value="displayItemList" :paginator="true" class="grid grid--uniform grid-products grid--view-items" style="width: 80%;margin-top: 3%;" :rows="28" :layout="layout">
            <template #header>
              <div class="p-grid p-nogutter">
              <InputText v-model="searchTerm"  style="float:right"  placeholder="Please enter keyword"  @input="searchItemWithUserInput"/>

              </div>
            </template>
            <template #grid="slotProps">
               <div class="p-col-12 p-md-3" style="border-bottom: 0px solid #c8c8c8;">
                 <div class="productList">
              <!-- <div class="grid grid--uniform grid-products grid--view-items"> -->
             
                  <!-- <div class="product-grid-item-top">
                    <div>
                      <i class="pi pi-tag product-category-icon"></i>
                      <span class="product-category">{{slotProps.data.groupName}}</span>
                    </div>
                  </div> -->
                  <div class="grid__item small--one-half medium--one-third large-up--one-quarter">
                  <div class="grid-view-item style1 wow fadeIn">
                  <div class="grid-view_image">
                    <a href="" >
                      <img   :src="slotProps.data.singleImageUrl" :alt="slotProps.data.name" style="height: 310px;width: 95%;"/></a>
                    <div class="grid-view-item__title">{{slotProps.data.name}}</div>
                    <span class="product-price__price" >Rs.{{slotProps.data.salesRate}}</span>
                    <div class="product-description">{{slotProps.data.description}}</div>
                  </div>
                  </div>
                  </div>
                <!-- </div> -->
              </div>
               </div>
            </template>
          </DataView>
             </div>
           </div>
         </div>
        </div>
                  <Dialog header="Product Details"  :modal="true" :visible.sync="showPosDialog" 
       :closable=false :style="{width: '50vw'}" :contentStyle="{'overflow': 'visible'}">
        <div class="p-fluid p-formgrid p-grid">
          <div class="p-field p-col-12 p-md-6">
              <label for="name"> Name: <span style="color:red">*</span></label>
              <span>{{this.itemName}}</span>
            </div>
            <div class="p-field p-col-12 p-md-6">
              <label for="shortName">Rate </label>
               <span>{{this.sellingPrice}}</span>
            </div>
            <!-- <div class="p-field p-col-12 p-md-6">
              <label for="manufactureDate">Discription: "</label>
               <span>{{this.description}}</span>
            </div> -->
            <!-- <div class="p-field p-col-12 p-md-6">
              <label for="expiryDate">Url </label>
               <span>{{this.imgUrl}}</span>
            </div> -->
           </div>
        <template #footer>
            <Button class="p-button-raised p-button-rounded" @click.prevent="cancel" label="Back"/>
            <!-- <Button @click.prevent="closeBasicBatchDetails" class="p-button-raised p-button-danger"
            label="Cancel"/> -->
        </template>
      </Dialog>
       
      <!-- </div> -->
       <footerWebsite ref="footerWebsite"/>
</form>

    <!-- </div> -->
</template>
<script>
import Dropdown from 'primevue/dropdown'
import Checkbox from 'primevue/checkbox'
import DatePicker from 'vue2-datepicker'
import Carousel from 'primevue/carousel'
import DataView from 'primevue/dataview'
import Galleria from 'primevue/galleria'
import AutoComplete from 'primevue/autocomplete'
import InputNumber from 'primevue/inputnumber'
import InputMask from 'primevue/inputmask'
import Button from 'primevue/button'
import InputText from 'primevue/inputtext'
import TextArea from 'primevue/textarea'
import website from '../ecommerce/website.vue'
import footerWebsite from '../ecommerce/footerWebsite.vue'
import Dialog from 'primevue/dialog'
export default {
  name: 'Shop',
  props: ['shop'],
  data() {
    return {
      name: '',
      layout: 'grid',
      sortOrder: null,
      searchTerm: '',
      sortField: null,
      showPosDialog: false,
      itemName: '',
      imgUrl: '',
      sellingPrice: '',
      description: '',
      displayItemList: [],
      sortOptions: [
       {label: 'Price High to Low', value: '!price'},
       {label: 'Price Low to High', value: 'price'}
      ]
    }
  },
  computed: {
  },
  mounted() {
    this.itemsList()
  },
  methods: {
    async itemsList() {
      let response = await this.$store.dispatch('loadItemMasterListForSite')
      this.displayItemList = response.data.data
    },
    searchItemWithUserInput () {
      // // debugger
      let filteredItemList = this.displayItemList.filter(item => {
        return item.name.toLowerCase().includes(this.searchTerm.toLowerCase())
      })
      this.displayItemList = filteredItemList
      if (filteredItemList.length !== 0) {
        this.salesItem = filteredItemList[0]
      }
      if (this.searchTerm === '') {
        this.itemsList()
      }
    },
    viewProductDetails(data) {
      // if (data !== undefined) {
      this.itemName = data.name
      this.imgUrl = data.singleImageUrl
      this.sellingPrice = data.salesRate
      this.description = data.description
      this.showPosDialog = true
        // this.$router.push({name: 'Product Details', params: { productObject: item }})
        // // debugger
      // }
    },
    async viewProductDetailsPage(data) {
      let PIHdata = {
        id: data.id,
        itemName: data.name,
        imgUrl: data.singleImageUrl,
        sellingPrice: data.salesRate,
        description: data.description,
        itemCode: data.itemCode,
        groupName: data.groupName,
        images: data.imageList
      }
      this.$router.push({name: 'Product Details', params: { productObject: PIHdata }, query: { item: data.id }})
    },
    cancel() {
      this.showPosDialog = false
    }
  },
  components: {
    Dropdown,
    DatePicker,
    Checkbox,
    AutoComplete,
    InputNumber,
    InputMask,
    Button,
    InputText,
    TextArea,
    Carousel,
    Galleria,
    DataView,
    Dialog,
    website,
    footerWebsite
  }
}
</script>
<style scoped  src="@../../../static/css/website.css" >
</style>



// WEBPACK FOOTER //
// shop.vue?705e6695